<template>
  <page :flex-container="true" :bg-color="bgColor">
    <div class="page-container">
      <div v-if="adTopInfo" class="img-wrapper">
        <div v-if="notice.length > 0" class="message">
          <scroll-notice :notice="notice" />
        </div>
        <img :src="adTopInfo" alt="" />
        <div class="top-hot">
          <div class="top-hot-left" @click="handleGoHistory">
            <img src="@/images/couponPack/icon_history.png" alt="" />
            <span class="text">购买记录</span>
          </div>
          <div class="line" />
          <div class="top-hot-right" @click="handleGoMyCoupon">
            <img src="@/images/couponPack/icon_coupon@3x.png" alt="" />
            <span class="text">我的优惠券</span>
          </div>
        </div>
      </div>
      <div v-if="adCouponInfo.imgUrl" class="adInfo" @click="handleAdInfoClick">
        <img :src="adCouponInfo.imgUrl" alt="" />
      </div>
      <div v-if="hotCouponpackList.length" class="upgrade-enjoy">
        <div class="title">热门推荐</div>
        <div class="coupons-list">
          <coupon-package
            v-for="item in hotCouponpackList"
            :key="item.id"
            :detail="item"
            :hot="true"
          />
        </div>
      </div>
      <div v-if="couponList.length" class="upgrade-enjoy">
        <div class="title">优惠券包</div>
        <div class="coupons-list" style="padding-bottom: 0.4rem">
          <coupon-package
            v-for="item in couponList"
            :key="item.id"
            :detail="item"
          />
        </div>
      </div>
    </div>
    <div v-if="hasPayingOrder" class="footer-btn" @click="handleGoHistory">
      您当前有券包未支付
      <span class="look-over">立即查看</span>
      <span class="arrow icon-arrow_right_l" />
    </div>
  </page>
</template>
<script>
import CouponPackage from './components/CouponPackage.vue'
import ScrollNotice from './components/ScrollNotice.vue'
import { API } from '@/api'
import { nativeRedirect } from '@/utils/native_interactions/native_redirect'
import { nativeRoutes } from '@/utils/native_interactions/native_redirect/routes'
import { navBar } from '@/utils/native_interactions/native_bar'
import couponPackTitle from '@/images/couponPack/title.png'
import { Bridge } from '@mc/mc-jsbridge'
export default {
  name: 'IntegralIndex',
  components: {
    CouponPackage,
    ScrollNotice
  },
  beforeRouteEnter(to, from, next) {
    next(v => {
      v.getCouponPackList()
      navBar.setTitle({
        text: '省钱券包'
      })
      Bridge.call('navigatePageSetting', { edgeInsets: { edge: 0 } })
      v.queryHasPayingOrders()
    })
  },
  data() {
    return {
      couponList: [],
      hotCouponpackList: [],
      adTopInfo: '',
      adCouponInfo: '',
      bgColor: '#f5f5f5',
      notice: [],
      hasPayingOrder: false
    }
  },
  created() {
    this.$Loading()
  },
  onLogin() {
    location.reload()
  },
  methods: {
    goBack() {
      this.$back()
    },
    handleGoHistory() {
      this.$track(this.$trackMap.memberCouponpack.btn_go_history)
      this.$router.push({
        name: 'memberCouponpackHistory'
      })
    },
    handleGoMyCoupon() {
      this.$track(this.$trackMap.memberCouponpack.btn_go_coupon_list)
      nativeRedirect(nativeRoutes.myCoupons)
    },
    handleAdInfoClick() {
      this.$autoRedirect(this.adCouponInfo.h5Url)
    },
    getCouponPackList() {
      API.memberCouponPack
        .getCouponPackList()
        .then(res => {
          this.couponList = res.couponPackList
          this.hotCouponpackList = res.hotCouponpackList
          this.adTopInfo = res.adTopInfo || couponPackTitle
          this.adCouponInfo = res.adCouponInfo
          this.bgColor =
            (res.acmConfig && res.acmConfig.pageBgColor) || '#FFF7EF'
          this.notice = res.message
        })
        .catch(e => {
          this.$catch(e, { title: '温馨提示', callback: () => this.goBack() })
        })
        .then(() => {
          this.$Loading.hide()
        })
    },
    queryHasPayingOrders() {
      API.memberCouponPack
        .queryHasPayingOrders()
        .then(res => {
          this.hasPayingOrder = !!res.hasOrder
        })
        .catch((this.hasPayingOrder = false))
    }
  }
}
</script>
<style lang="scss" scoped>
.page {
  display: flex;
  flex-direction: column;
  .page-container {
    flex: 1;
    overflow-y: scroll;
  }
  .footer-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 0.8rem;
    background-image: linear-gradient(to right, #ff7d5e 0%, #ff3410 100%);
    font-size: 0.28rem;
    color: #fff;
    .look-over {
      margin-left: 0.24rem;
      font-size: 0.32rem;
    }
    .arrow {
      font-size: 0.24rem;
    }
  }
}
.img-wrapper {
  position: relative;
  width: 100%;
  min-height: 4.3rem;
  img {
    width: 100%;
  }
  .top-hot {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff7ef;
    width: 7.1rem;
    height: 1.2rem;
    border-radius: 0.2rem;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.06);
    .line {
      height: 0.4rem;
      width: 1px;
      background-color: #ebe1d3;
    }
    &-left,
    &-right {
      padding: 0.2rem 0;
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 0.4rem;
        height: 0.4rem;
      }
      .text {
        margin-left: 0.1rem;
        font-size: 0.28rem;
        color: #333;
      }
    }
  }
}
.adInfo {
  width: 100%;
  img {
    width: 100%;
  }
}
.title {
  margin: 0.52rem 0 0.24rem;
  font-size: 0.4rem;
  color: #333;
  height: 0.56rem;
  line-height: 0.56rem;
  font-weight: 600;
}
.upgrade-enjoy {
  width: 100%;
  padding: 0 0.2rem;
  overflow: hidden;
  box-sizing: border-box;
}

.message {
  position: absolute;
  top: 0.22rem;
  padding-left: 0.48rem;
  width: 5.2rem;
  height: 0.64rem;
  line-height: 0.64rem;
  font-size: 0.24rem;
  color: #fff;
  background-image: linear-gradient(to left, #ff532f 0%, #ff8d47 80%);
  overflow: hidden;
}
</style>
